import { Select } from "antd";
import { applyTagSelection, labelError } from "@utils/notesForm.mjs";

interface NoteTagsFieldProps {
    tags: string[];
    /** The tags of the team. They show as suggestions. */
    knownTags: string[];
    disabled?: boolean;
    /** `error` is the message of a tag the user typed and the rule refused, or null. */
    onChange: (tags: string[], error: string | null) => void;
}

export const NoteTagsField = ({ tags, knownTags, disabled, onChange }: NoteTagsFieldProps) => (
    <Select
        id="notes-dialog-tags"
        className="notes-full-width"
        mode="tags"
        disabled={disabled}
        placeholder="Choose or type a tag"
        value={tags}
        options={knownTags.map((name) => ({ value: name }))}
        // The text being typed shows as the first option. When it is not a tag yet, a hint says how to create it,
        // or why it can't be a tag. A tag the note has already is not new.
        optionRender={(option) => {
            const value = String(option.value);
            const isNew = ![...knownTags, ...tags].some((t) => t.toLowerCase() === value.toLowerCase());
            if (!isNew) return value;
            const error = labelError(value);
            return (
                <span className="notes-tag-option">
                    <span className="notes-tag-option-text">{value}</span>
                    <span className={`notes-tag-option-hint${error ? " notes-tag-option-hint-error" : ""}`}>
                        {error ?? "Press Enter to create this tag"}
                    </span>
                </span>
            );
        }}
        onChange={(values: string[]) => {
            const result = applyTagSelection(tags, values, knownTags);
            onChange(result.tags, result.error);
        }}
    />
);
